export default __webpack_public_path__ + "static/media/logo_login.b1ad2eb9.jpg";